@if (lockerSpirit) {
    <div class="locker">
        <div class="locker-header">
            <span class="locker-label">
                {{ 'locker.detail.title' | translate }}
            </span>
            <div class="locker-access" (click)="lockerExpanded = !lockerExpanded">
                <locker-icon></locker-icon>
                <button mat-icon-button [class.rotated]="lockerExpanded">
                    <chevron-down-icon></chevron-down-icon>
                </button>
            </div>
        </div>
        <div class="locker-details" [class.expanded]="lockerExpanded">
            <div class="locker-details-header">
                <p>{{ 'locker.detail.quantity' | translate }}: {{ lockerSpirit.quantity }}</p>
                <div class="locker-details-actions">
                    @if (lockerSpirit.quantity > 0) {
                        <button mat-flat-button color="primary" (click)="openConsumptionDialog()">
                            <span>{{ 'locker.detail.add_consumption' | translate }}</span>
                        </button>
                    }
                    @if (lockerSpirit.quantity == 0) {
                        <button mat-flat-button color="primary" (click)="openDeleteDialog()">
                            <span>{{ 'locker.delete.title' | translate }}</span>
                        </button>
                    }
                </div>
            </div>
            @if (lockerSpirit.notes) {
                <div class="locker-details-notes">
                    <b>{{ 'locker.detail.notes' | translate }}</b>
                    <small>{{ lockerSpirit.notes }}</small>
                </div>
            }
            @if (lockerSpirit.consumptions && lockerSpirit.consumptions!.length > 0) {
                <div class="locker-details-consumptions">
                    <div class="locker-details-consumptions-header">
                        <b (click)="openImageUploadDialog($event)">{{ 'locker.detail.last_consumption' | translate }}</b>
                        <button mat-button class="text-white" (click)="openConsumptionHistoryDialog()">{{ 'locker.detail.view_history' | translate }}</button>
                    </div>
                    <div class="locker-details-consumptions-body">
                        <div>
                            <small>{{ 'locker.detail.date' | translate }}: <b>{{ lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].createdAt | date: 'dd/MM/yyyy' }}</b></small>
                            <small>{{ 'locker.detail.quantity' | translate }}: <b>{{ lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].quantity }}</b></small>
                            <small>
                                {{ 'locker.detail.status' | translate }}:
                                <b>{{ ('locker.detail.status_' + lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].status) | translate }}</b>
                                @if (lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].status == 'partial') {
                                    <b>({{ lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].remainingQuantity }}%)</b>
                                }
                            </small>
                            <small class="notes">{{ lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].notes }}</small>
                        </div>
                        @if (lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].photoUrl) {
                            <div class="consumption-photo-wrapper" (click)="openImageDialog(apiUrl + lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].photoUrl)">
                                <img [src]="apiUrl + lockerSpirit.consumptions[lockerSpirit.consumptions.length - 1].photoUrl" alt="Foto tomada">
                                <mat-icon class="zoom-icon">zoom_in</mat-icon>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}

@if ((menu && !menu.user.activeModules.includes('erp')) || !spirit!.stock || (spirit!.stock && !(spirit!.stock!.stockActive && spirit!.stock!.stock == 0))) {
    <button mat-button (click)="showAddToLockerQty = true" color="primary">{{ 'locker.detail.add' | translate }}</button>
    @if (showAddToLockerQty) {
        <app-spirit-detail-locker-add [menu]="menu" [spirit]="spirit" (spiritAdded)="addToLocker()"></app-spirit-detail-locker-add>
    }
}